module.exports = __webpack_public_path__ + "static/media/noimg.488f052b.png";